











import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { SchemaField } from '@/types';

@Component({
  components: {},
})
export default class Rule extends Vue {
  @Prop() private rule: any;
  @Prop() private fields!: any[];
  @Prop() private validate!: number;


}
